<template>
    <div class="content">
      <el-row class="bgW">
        <el-col :span="22">
          <!--检索条件-->
          <el-form :inline="true" size="mini" :model="search">
            <el-form-item label="开卡日期">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                class="w300"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchTime"
              ></el-date-picker>
            </el-form-item>
  
            <el-form-item label="店铺名称" v-if="!userInfo.shop_id">
              <el-select
                v-model="search.shop_id"
                clearable
                remote
                filterable
                :remote-method="remoteMethod"
                placeholder="请输入店铺名称"
                class="w120 mr20"
                @change="getStaff1"
              >
                <el-option
                  v-for="item in options.shop_id"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>
             <el-form-item label="护理师">
              <el-input
                v-model="search.person_name"
                maxlength="30"
                class="w120 mr20"
                placeholder="请输入护理师名称"
                clearable
              />
          </el-form-item>
  
          <el-form-item label="卡项名称" v-if="!clienId">
                <el-input
                  v-model="search.name"
                  maxlength="30"
                  class="w120 mr20"
                  placeholder="请输入卡项名称"
                  clearable
                />
          </el-form-item>
            <el-form-item label="顾客名称" v-if="!clienId">
              <el-input
                v-model="search.customer_name"
                maxlength="30"
                class="w100"
                placeholder="请输入顾客名称"
                clearable
              />
            </el-form-item>
            <el-form-item label="顾客电话" v-if="!clienId">
              <el-input
                v-model="search.telephone"
                maxlength="30"
                class="w100"
                placeholder="请输入顾客电话"
                clearable
              />
            </el-form-item>
            <el-form-item label="会员等级" v-if="!clienId">
              <el-select
                v-model="search.membership_leve"
                clearable
                class="w100"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in options.membership_leve"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>


          </el-form>
        </el-col>
        <el-col :span="2" style="text-align: right;">
          <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="exportData('export')">导出</el-button>
        </el-col>
      </el-row>
      <el-row class="mt30">
        <el-col :span="24">
          <el-table
            :data="list"
            size="small"
            border
            :cell-style="$style.cellStyle"
            :header-cell-style="$style.rowClass"
          >
            <ElTableColumn label="建档时间" prop="customer_create_time" width="100" />

            <ElTableColumn label="护理师" prop="person_name" width="90" />

            <ElTableColumn label="顾客姓名" prop="customer_name" width="90" />

            <ElTableColumn label="手机号" prop="telephone" width="110" />

            <ElTableColumn label="会员等级" prop="grade_name" width="80" />

            <ElTableColumn label="账户金额" prop="account_money" width="90" />

            <ElTableColumn label="卡项名称" prop="name" min-width="140" show-overflow-tooltip />

            <ElTableColumn label="开卡时间" prop="create_time" width="100" />

            <ElTableColumn label="成交金额" prop="cj_money" width="90" />

            <ElTableColumn label="卡项次数/到期时间" width="200">
              <template slot-scope="{ row }">
                <span v-if="row.service_type == 1">{{ row.start_time }} 至 {{ row.end_time }}</span>
                <span v-else>{{ row.num }}次</span>
              </template>
            </ElTableColumn>

            <ElTableColumn label="最近核销时间" prop="last_verify_time" width="150" />

            <ElTableColumn label="剩余次数" prop="yy_num" width="80" />

            <ElTableColumn label="本月是否核销" width="100" align="center">
              <template slot-scope="{ row }">
                <el-tag :type="row.is_month_verify == 1 ? 'success' : 'info'" size="mini">
                  {{ row.is_month_verify == 1 ? '是' : '否' }}
                </el-tag>
              </template>
            </ElTableColumn>

            <!-- <ElTableColumn label="操 作" fixed="right" width="90">
              <template slot-scope="{ row }">
                <span class="theme ml20" @click="tapDetail(row.id)">查 看</span>
              </template>
            </ElTableColumn> -->
          </el-table>
          <pagination
            class="page tc mt10"
            :total="page.total"
            :page.sync="page.page"
            :limit.sync="page.limit"
            @pagination="getList"
          />
        </el-col>
      </el-row>
    </div>
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  import pagination from "@/components/Pagination";
  import { serviceList, addServiceLog, gbservice,changeService,serviceInfo,pastServiceList,getGradeList } from "@/api/client";
  import { staffList } from "@/api/staff";
  import { getShopList } from "@/api/shop";
  import { apply, auditDetail,serviceRegainApply,expiredServiceApply } from "@/api/serviceConsume";
  
  class Search {
    person_name = ""; // 护理师
    start_time = ""; // 开卡开始日期
    endTime = ""; // 开卡结束日期
    customer_name = ""; // 顾客名称
    telephone = ""; // 顾客电话
    membership_leve = ""; // 会员等级
    shop_id = ""; // 店铺
    serve_serve_name = ""; // 卡项名称
  }
  class Page {
    total = 0;
    page = 1;
    limit = 10;
  }
  class VerifyDetail {
    service_id = "";
    nurse_id_one = "";
    nurse_id_two = "";
    num = "";
    start_time = "";
    end_time = "";
  }
  
  class changeData {
    service_id = "";
    num = "";
    end_time = "";
  }
  
  class Rules {
    nurse_id_one = [
      { required: true, message: "请选择护理师", trigger: "change" }
    ];
    num = [{ required: true, message: "请输入服务次数", trigger: "blur" }];
  }
  
  class Options {
    staff_id = []; // 护理师
    constructor() {
      this.shop_id = []; // 店铺
    }
    membership_leve = []; // 会员等级
    sale_id = [];
    effective = [
      { id: 15, name: "15天" },
      { id: 30, name: "30天" },
      { id: 45, name: "45天" },
      { id: 60, name: "60天" }
    ];
  }
  
  //卡项消耗申请
  class ApplyDetail {
    reason = "";
  
  }
  
  //卡项消耗恢复申请
  class ApplyRegainDetail {
    reason = "";
  
  }
  
  class auditDetails {
    service={};
  }
  
  class serviceDetail {
    kk_money = '0.00';
    consume_money = '0.00';
    consume_gratuity = '0.00';
    consume_store_transfer = '0.00';
    consume_bj = '0.00';
    consume_zj = '0.00';
    consume_dz = '0.00';
    consume_num = 0
    
  }
  
  export default {
    name: "ServeRecord",
    components: {
      pagination
    },
    props: {
      clienId: {
        type: String,
        default: ""
      },
      detail: {
        type: Object,
        default: () => {
          return {};
        }
      }
    },
    data() {
      return {
        search: new Search(),
        verifyDetail: new VerifyDetail(),
        applyDetail: new ApplyDetail(), //卡项消耗申请表单
        applyRegainDetail:new ApplyRegainDetail(),
        changeData: new changeData(),
        serviceDetail : new serviceDetail(),//卡项信息
        options: new Options(),
        rules: new Rules(),
        page: new Page(), // 分页
        list: [], // 数据展示
        auditDetails:new auditDetails(),
        auditDetailList :[],
        verificationPop: false, //核销弹出
        changeNumPop: false, //调整弹出_次卡
        changeDatePop: false, //调整弹出_月卡
        applyPop:false,
        applyConsumePop:false,
        applyRegainPop:false,
        serviceDetailPop:false,
        tableData:[],
        timeValue: [],
        value1: [],
        pickerBeginDateBefore: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        }
       
      };
    },
  
    mounted() {
      this.getList();
      this.getStaff1();
      getGradeList().then(res => {
        this.options.membership_leve = res.list || [];
      });
    },
    computed: {
      ...mapGetters(["userInfo"])
    },
    methods: {
    getStaff1() {
      staffList({ page: 1, limit: 1000000, shopId: this.search.shop_id }).then(
        res => {
          this.options.staff_id = res.list;
        }
      );
    },
      // 获取列表
      getList(option) {
        if (option === "search") this.page = new Page();
        pastServiceList({
          ...this.search,
          customer_id: this.clienId,
          ...this.page
        }).then(res => {
          this.list = res.list;
          this.page.total = res.dataCount;
        });
        this.getStaff();
      },
  
      // 导出
      exportData(option){
        serviceList({
          ...this.search,
          export : 1
        }).then(res => {
          window.open(res.url);
        });
        this.getStaff();
      },
  
      // 客户所在店铺员工列表
      getStaff() {
        staffList({ page: 1, limit: 1000000, shopId: this.detail.shopid_U }).then(
          res => {
            this.options.sale_id = res.list;
          }
        );
      },
      // 重复护理师提示
      changeStaff() {
        if (this.verifyDetail.nurse_id_one == this.verifyDetail.nurse_id_two) {
          this.$message({
            type: "warning",
            message: "请选择不同护理师"
          });
          this.verifyDetail.nurse_id_two = "";
        }
      },
      // 开卡日期搜索
      searchTime(val) {
        if (val) {
          this.search.start_time = val[0];
          this.search.endTime = val[1];
        } else {
          this.search.start_time = "";
          this.search.endTime = "";
          this.getList("search");
        }
      },
      // 搜索门店
      remoteMethod(e) {
        getShopList({ page: 1, limit: 100000, shopName: e }).then(res => {
          this.options.shop_id = res.list;
        });
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  </style>
  